import { Component, EventEmitter, Input, Output } from "@angular/core";

import { DialogModule } from "primeng/dialog";

@Component({
  selector: "app-month-details",
  standalone: true,
  imports: [DialogModule],
  templateUrl: "./month-details.component.html",
  styleUrl: "./month-details.component.scss",
})
export class MonthDetailsComponent {
  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  close(): void {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }
}
